import React, { useMemo } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { ReusableDataGrid } from "../shared/ReusableDataGrid";
import { Referral } from "./types/referral";

interface ReferralDisplay {
  id: string;
  patientEmail: string;
  fromProviderName: string;
  toProviderName: string;
  reason: string;
  notes: string;
  status: string;
  date: string;
  time: string;
}

/* =====================
   Props
===================== */
interface Props {
  data: Referral[];
}

/* =====================
   Component
===================== */

export default function ReferralTableReceived({ data }: Props) {
  /* =====================
     Map API data → Grid data
  ===================== */
  const rows: ReferralDisplay[] = useMemo(() => {
    return data.map((item) => {
      const createdDate = new Date(item.created_at);

      return {
        id: item.id,
        patientEmail: item.patient?.email || "-",
        fromProviderName: item.from_provider?.provider
          ? `${item.from_provider.provider.first_name} ${item.from_provider.provider.last_name}`
          : "-",
        toProviderName: item.to_provider?.provider
          ? `${item.to_provider.provider.first_name} ${item.to_provider.provider.last_name}`
          : "-",
        reason: item.reason || "-",
        notes: item.notes || "-",
        status: item.status || "Pending",
        date: createdDate.toLocaleDateString(),
        time: createdDate.toLocaleTimeString(),
      };
    });
  }, [data]);

  /* =====================
     Columns
  ===================== */
  const columns: GridColDef[] = useMemo(
    () => [
      { field: "patientEmail", headerName: "Patient Email", width: 220 },
      { field: "fromProviderName", headerName: "From Provider", width: 200 },
      { field: "toProviderName", headerName: "To Provider", width: 200 },
      { field: "reason", headerName: "Reason", width: 220 },
      { field: "notes", headerName: "Notes", width: 220 },
      { field: "status", headerName: "Status", width: 120 },
      { field: "date", headerName: "Date", width: 130 },
      { field: "time", headerName: "Time", width: 130 },
    ],
    []
  );

  return (
    <div style={{ height: 500, width: "100%" }}>
      <ReusableDataGrid
        columns={columns}
        data={rows}
        getRowId={(row) => row.id}
      />
    </div>
  );
}
